module.exports = __webpack_public_path__ + "static/media/BORRAR_DATOS.7268deee.jpg";